import ErplyAPI from 'service/ErplyAPI';

export const getCompanyInfo = () => ErplyAPI.request('getCompanyInfo');
export const editCompanyInfo = (params) =>
  ErplyAPI.request('editCompanyInfo', params);
